module.exports = __webpack_public_path__ + "img/avatar3.05048c1e.png";